const addCloseButtonListenerMobileSimple = (mobileSimpleOffer) => {
    document.addEventListener("click", (e) => {
        mobileSimpleOffer = document.querySelector(".c-simple-mobile");
        const openButton = mobileSimpleOffer.querySelector(".c-simple-mobile__open_button");
        const simpleContent = mobileSimpleOffer.querySelector(".c-simple-mobile__content");
        const mobileHubButton = document.querySelector(".c-mobile-hub__btn");

        if (e.target.closest(".c-simple-mobile__open_button") || e.target.closest(".c-simple-overlay")) {
            simpleContent?.classList.toggle("is-hidden");
            openButton?.classList.toggle("is-active");

            mobileHubButton && mobileHubButton.classList.toggle("is-visible");
            setCookie("simpleOfferMobileShown", true, 1, "/");
            noScrollSimpleMobileToggle(mobileSimpleOffer, false);
        }
    });
}

const noScrollSimpleMobileToggle = (mobileSimpleOffer, noScroll = true) => {
    const isMobile = window.innerWidth < 560;

    if (mobileSimpleOffer.classList.contains('c-simple-mobile--small') || !isMobile) {
        return;
    }

    if (noScroll) {
        document.body.classList.toggle("no-scroll");
    }

    document.querySelector(".c-simple-overlay")?.classList.toggle("is-active");
};

(function() {
    const simpleOffer = document.querySelector(".c-simple");
    const mobileSimpleOffer = document.querySelector(".c-simple-mobile");
    const liveChat = document.querySelector("#c-livechat");
    let isShown = false;

    if (!getCookie("simpleOfferClose") && simpleOffer) {
        const simpleClose = document.querySelector(".c-simple__close");

        const scrollHandler = function() {
            let st = window.pageYOffset || document.documentElement.scrollTop;
            let sh = document.documentElement.scrollHeight;
            let wh = window.innerHeight;

            let scrollPercentage = (st / (sh - wh)) * 100;

            if (scrollPercentage > 50) {
                simpleOffer.classList.add("active");
                liveChat && liveChat.classList.add("is-hidden");
            }
        };

        window.addEventListener("scroll", scrollHandler);

        simpleClose?.addEventListener("click", function() {
            simpleOffer.classList.remove("active");
            liveChat && liveChat.classList.remove("is-hidden");
            isOpened = true;

            setCookie("simpleOfferClose", true, 1, "/");
            window.removeEventListener("scroll", scrollHandler);
        });
    }

    if (!mobileSimpleOffer || getCookie("simpleOfferMobileShown")){
        return;
    }

    const addClassOnScroll = (mobileSimpleOffer, scrollThreshold) => {
        const scrollPosition = window.scrollY;
        const windowHeight = window.innerHeight;
        const documentHeight = document.body.scrollHeight;
        const isMobile = window.innerWidth < 560;
        mobileSimpleOffer = document.querySelector(".c-simple-mobile");
        const mobileHubButton = document.querySelector(".c-mobile-hub__btn");
        const scrollPercentage = scrollPosition / (documentHeight - windowHeight);

        if (scrollPercentage >= scrollThreshold && !isShown && isMobile) {
            mobileSimpleOffer.classList.add("is-active");
            noScrollSimpleMobileToggle(mobileSimpleOffer, false);
            isShown = true;
            document.documentElement.style.paddingBottom = "3rem";

            mobileHubButton && mobileHubButton.classList.toggle("is-visible");
        }
    }

    const mobileSimpleOfferSetup = (mobileSimpleOffer) => {
        const scrollThreshold = 0.5;
        window.addEventListener("scroll", () => {
            addClassOnScroll(mobileSimpleOffer, scrollThreshold);
        });
    };

    mobileSimpleOfferSetup(mobileSimpleOffer);
    addCloseButtonListenerMobileSimple(mobileSimpleOffer);
})();
